<template>
  <div>
    <div class="row" v-if="!loading">
      <div class="col-md-8">
        <div class="card shadow-card">
          <form class="card-body" @submit.prevent="updateVendor">
            <div class="form-group">
              <label>Company Name</label>
              <input
                type="text"
                v-model="vendor.name"
                class="form-control"
                :disabled="!userHasControl"
              />
            </div>
            <div class="form-group">
              <label>Company Bio</label>
              <textarea
                v-model="vendor.bio"
                :disabled="!userHasControl"
                v-autosize
                class="form-control"
                rows="1"
                ref="bio"
                placeholder="Add Company Bio"
              ></textarea>
            </div>
            <div class="form-group">
              <label>Company Email</label>
              <input
                type="email"
                v-model="vendor.email"
                class="form-control"
                :disabled="!userHasControl"
              />
            </div>
            <div class="form-group">
              <label>Company Website</label>
              <input
                type="text"
                v-model="vendor.site"
                class="form-control"
                :disabled="!userHasControl"
              />
            </div>
            <div class="form-group">
              <label>Company Phone</label>
              <input
                type="text"
                v-model="vendor.phone"
                :key="vendor.email"
                v-cleave="cleave.phone"
                class="form-control"
                :disabled="!userHasControl"
              />
            </div>
            <div class="form-group">
              <label>Booking Link</label>
              <input
                type="text"
                v-model="vendor.booking_link"
                :key="vendor.email"
                placeholder="https://www.vendor-booking.com"
                class="form-control"
                :disabled="!userHasControl"
              />
            </div>
            <div class="card">
              <div class="card-body">
                <div class="row m-0 align-items-center justify-content-between">
                  <h3 class="mb-0 d-flex align-items-center">
                    Avatar
                    <img
                      v-if="vendorAvatar"
                      :src="vendorAvatar"
                      class="avatar-img"
                      alt="map avatar"
                    />
                  </h3>
                  <button
                    type="button"
                    @click="editAvatar"
                    v-if="userHasControl"
                    class="btn btn-info btn-sm mr-2"
                  >
                    <i class="fas fa-edit fa-fw"></i>
                  </button>
                </div>
              </div>
            </div>
            <div class="d-flex row m-0">
              <div class="form-group mr-5">
                <label>Accepting Referrals</label>
                <div class="custom-control custom-switch">
                  <input
                    type="checkbox"
                    class="custom-control-input"
                    id="customSwitch_referrals"
                    :disabled="!userHasControl"
                    v-model="allow_referrals"
                  />
                  <label
                    class="custom-control-label"
                    for="customSwitch_referrals"
                  >
                    <badge
                      type="pill"
                      :color="allow_referrals ? 'success' : 'danger'"
                    >
                      <span
                        v-html="
                          allow_referrals
                            ? `<i class='fas fa-check fa-fw'></i> Active`
                            : `<i class='fas fa-times fa-fw'></i> Inactive`
                        "
                      ></span>
                    </badge>
                  </label>
                </div>
              </div>
              <div class="form-group mr-5">
                <label>Accepting Documents</label>
                <div class="custom-control custom-switch">
                  <input
                    type="checkbox"
                    class="custom-control-input"
                    id="customSwitch_documents"
                    :disabled="!userHasControl"
                    v-model="allow_documents"
                  />
                  <label
                    class="custom-control-label"
                    for="customSwitch_documents"
                  >
                    <badge
                      type="pill"
                      :color="allow_documents ? 'success' : 'danger'"
                    >
                      <span
                        v-html="
                          allow_documents
                            ? `<i class='fas fa-check fa-fw'></i> Active`
                            : `<i class='fas fa-times fa-fw'></i> Inactive`
                        "
                      ></span>
                    </badge>
                  </label>
                </div>
              </div>
              <div class="form-group mr-5">
                <label>Accepting From</label>
                <div class="custom-control custom-switch">
                  <input
                    type="checkbox"
                    class="custom-control-input"
                    id="customSwitch_public"
                    :disabled="!userHasControl"
                    v-model="prevent_public"
                  />
                  <label class="custom-control-label" for="customSwitch_public">
                    <badge
                      type="pill"
                      :color="prevent_public ? 'success' : 'danger'"
                    >
                      <span
                        v-html="
                          prevent_public
                            ? `<i class='fas fa-check fa-fw'></i> Vendors Only`
                            : `<i class='fas fa-times fa-fw'></i> All`
                        "
                      ></span>
                    </badge>
                  </label>
                </div>
              </div>
              <div class="form-group">
                <label>Seen By Vendors Only</label>
                <div class="custom-control custom-switch">
                  <input
                    type="checkbox"
                    class="custom-control-input"
                    id="customSwitch_vendors_seen_only"
                    :disabled="!userHasControl"
                    v-model="vendors_seen_only"
                  />
                  <label
                    class="custom-control-label"
                    for="customSwitch_vendors_seen_only"
                  >
                    <badge
                      type="pill"
                      :color="vendors_seen_only ? 'success' : 'danger'"
                    >
                      <span
                        v-html="
                          vendors_seen_only
                            ? `<i class='fas fa-check fa-fw'></i> Vendors Only`
                            : `<i class='fas fa-times fa-fw'></i> All`
                        "
                      ></span>
                    </badge>
                  </label>
                </div>
              </div>
            </div>
            <div class="form-group" v-if="user.isAdmin">
              <label>Status</label>
              <div class="custom-control custom-switch">
                <input
                  type="checkbox"
                  class="custom-control-input"
                  id="customSwitch1"
                  :checked="active"
                  :disabled="!userHasControl"
                  @change="userHasControl && toggleActive()"
                />
                <label class="custom-control-label" for="customSwitch1">
                  <badge type="pill" :color="activatingColor">
                    <span v-if="vendors.activating"
                      ><i class="fas fa-circle-notch fa-spin fa-fw"></i>
                      Saving...</span
                    >
                    <span
                      v-if="!vendors.activating"
                      v-html="
                        active
                          ? `<i class='fas fa-check fa-fw'></i> Active`
                          : `<i class='fas fa-times fa-fw'></i> Not Active`
                      "
                    ></span>
                  </badge>
                </label>
              </div>
            </div>
            <div class="text-center" v-if="userHasControl">
              <button :disabled="saving" class="btn btn-info col-6 col-sm-4">
                <span v-if="!saving">Save</span>
                <span
                  class="spinner-border spinner-border-sm"
                  v-if="saving"
                  role="status"
                  aria-hidden="true"
                ></span>
              </button>
            </div>
          </form>
        </div>
        <upload-media :disabled="!userHasControl" class="shadow-card" />
        <div class="card shadow-card">
          <div class="card-body" data-v-step="vendorServices">
            <div
              class="row m-0 mb-4 align-items-center justify-content-between"
            >
              <h3 class="mb-0">Services/Specialties</h3>
              <button
                type="button"
                @click="editServices"
                v-if="userHasControl"
                class="btn btn-info btn-sm mr-2"
              >
                <i class="fas fa-edit fa-fw"></i>
              </button>
            </div>
            <div v-if="!vendorServices.length">
              No services attached to this vendor yet.
            </div>
            <ul
              class="service-items d-flex flex-wrap p-0"
              v-if="vendorServices.length"
            >
              <li
                class="service-item col-12 col-sm-6 col-md-4 d-flex align-items-center justify-content-center"
                v-for="service in vendorServices"
                :key="service.id"
              >
                <div
                  class="service-item-container text-center d-flex w-100 align-items-center justify-content-center"
                >
                  {{ service.name }}
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="col-md-4">
        <div class="card shadow-card" data-v-step="inviteVendor">
          <div
            class="card-body d-flex justify-content-between align-items-center"
          >
            <img src="/images/add-user.png" style="height: 54px" />
            <div>
              <button @click="addUsersToInvite" class="btn btn-danger mr-2">
                Invite User
              </button>
            </div>
          </div>
        </div>
        <upload-logo
          class="shadow-card"
          :vendorId="parseInt($route.params.id)"
          :disabled="!userHasControl"
        />
        <div class="card shadow-card">
          <div class="card-body">
            <embed-code></embed-code>
          </div>
        </div>
      </div>
    </div>
    <invite-users :vendor="vendor" v-if="modal.showing"></invite-users>
    <edit-vendor-services
      :vendorId="parseInt($route.params.id)"
      :allServices="mainServices"
      :vendorServices="vendorServices"
      v-if="modal.showing"
    />
    <edit-vendor-avatar
      :vendor="vendor"
      v-if="modal.showing"
      :disabled="!userHasControl"
    />
  </div>
</template>

<script>
import UploadLogo from "./UploadLogo";
import UploadMedia from "./UploadMedia";
import EditVendorServices from "./EditServices";
import EditVendorAvatar from "./EditAvatar";
import InviteUsers from "./InviteUsers";
import EmbedCode from "./EmbedCode";
import { mapState } from "vuex";
import Swal from "sweetalert2";
import Auth from "../../../auth";

export default {
  name: "Profile",
  components: {
    UploadLogo,
    UploadMedia,
    EditVendorServices,
    EditVendorAvatar,
    EmbedCode,
    InviteUsers,
  },
  data() {
    return {
      email: "",
      phone: "",
      allow_referrals: true,
      allow_documents: true,
      prevent_public: true,
      vendors_seen_only: false,
      cleave: {
        phone: { blocks: [3, 3, 8], delimiter: "-", numericOnly: true },
      },
    };
  },
  computed: {
    ...mapState(["saving", "vendors", "loading", "user", "modal"]),
    ...mapState({
      services: (state) => (state.services || {}).data,
    }),
    loggedInUser: function () {
      return Auth.user.get();
    },
    userHasControl: function () {
      if (!this.vendor) {
        return false;
      }
      if (
        this.loggedInUser.isAdmin ||
        ((this.vendor.admins || []).length &&
          this.vendor.admins.includes(this.loggedInUser.id))
      ) {
        return true;
      }
      return false;
    },
    mainServices: function () {
      if (this.services && this.services.length) {
        return this.services.map((service) => {
          return {
            id: service.id,
            name: service.name,
          };
        });
      }
      return [];
    },
    vendorServices: function () {
      if (this.mainServices.length && this.vendor.services) {
        return this.vendor.services;
      }
      return [];
    },
    vendor: function () {
      return this.vendors.single;
    },
    active: function () {
      return this.vendors.single.active ? true : false;
    },
    activatingColor: function () {
      if (this.vendors.activating) {
        return "secondary";
      }
      return this.active ? `success` : `danger`;
    },
    vendorAvatar: function () {
      if (this.vendor) {
        return `/images/map-avatars/${this.vendor.avatar_type || 0}.png`;
      }
      return "";
    },
  },
  mounted() {
    if (this.$route.params.id != this.vendor.id) {
      this.getVender(this.$route.params.id);
      this.$store.dispatch("services/all");
    } else {
      this.allow_referrals = !this.vendor.prevent_referrals;
      this.allow_documents = !this.vendor.prevent_documents;
      this.prevent_public = this.vendor.prevent_public_referrals;
      this.vendors_seen_only = this.vendor.vendors_seen_only;
    }
  },
  methods: {
    getVender: function (id) {
      this.$store.dispatch("vendors/get", { id }).then((vendor) => {
        if (vendor) {
          this.allow_referrals = !vendor.prevent_referrals;
          this.allow_documents = !vendor.prevent_documents;
          this.prevent_public = vendor.prevent_public_referrals;
          this.vendors_seen_only = vendor.vendors_seen_only;
        }
      });
    },
    updateVendor: function () {
      this.vendor.prevent_referrals = !this.allow_referrals;
      this.vendor.prevent_documents = !this.allow_documents;
      this.vendor.prevent_public_referrals = this.prevent_public;
      this.vendor.vendors_seen_only = this.vendors_seen_only;
      if (this.vendor.booking_link) {
        const urlPattern =
          /^(https?:\/\/)([\da-z.-]+)\.([a-z.]{2,6})([/\w .-]*)*\/?$/;
        if (!urlPattern.test(this.vendor.booking_link)) {
          return Swal.fire({
            title: "Error",
            text: "Invalid booking Link",
            type: "error",
          });
        }
      }
      if (this.phone) {
        this.vendor.phone = this.phone;
      }
      if (this.email) {
        this.vendor.email = this.email;
      }
      this.$store.commit("SET_SAVING_STATE", true, { root: true });
      this.$store.dispatch("vendors/update", this.vendor);
    },
    editServices: function () {
      this.$store.dispatch("showModal", "edit-vendor-services");
    },
    editAvatar: function () {
      this.$store.dispatch("showModal", "edit-vendor-avatar");
    },
    addUsersToInvite: function () {
      this.$store.dispatch("showModal", "invite-users");
    },
    toggleActive: function () {
      this.$store.dispatch("vendors/toggleActivation", {
        vendor: this.vendor,
        active: this.active,
      });
    },
  },
};
</script>

<style scoped>
.service-item {
  padding: 3px;
}
.service-item-container {
  height: 100%;
  background-color: #5c6bc0;
  color: #fff;
  border-radius: 4px;
  padding: 7px;
  font-size: 0.85em;
}
input:disabled,
textarea:disabled {
  color: #aaaaaa;
}
.avatar-img {
  cursor: pointer;
  height: 72px;
  margin-left: 12px;
}
</style>
